import { useState, useMemo, useEffect } from "react";
import { Modal, Form, ListGroup } from "react-bootstrap";
import { getAllDistricts } from "../../../api/axios/requests";

let districtCache = null;

export default function DistrictSelectorModal({ show, onClose, onSelect }) {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    if (!show) return;

    const fetchDistricts = async () => {
      setLoading(true);

      // ⏱ Check if cache exists
      if (districtCache) {
        setDistricts(districtCache);
        setLoading(false);
        return;
      }

      try {
        const res = await getAllDistricts();
        const result = res?.data || [];
        districtCache = result;
        setDistricts(result);
      } catch (err) {
        console.error("Failed to fetch districts:", err);
        setDistricts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDistricts();
  }, [show]);

  const filtered = useMemo(() => {
    return districts.filter((d) =>
      d.name.toLowerCase().includes(query.toLowerCase())
    );
  }, [query, districts]);

  return (
    <Modal show={show} onHide={onClose} centered={false}>
      <Modal.Header closeButton>
        <Modal.Title>Байршил сонгох</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="text"
          placeholder="Байршил хайх..."
          className="mb-2"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          disabled={loading}
        />

        {loading ? (
          <ListGroup variant="flush">
            {[...Array(10)].map((_, idx) => (
              <div
                key={idx}
                className="list-group-item placeholder-glow d-flex align-items-center"
              >
                <span className="placeholder col-12 py-2 rounded" />
              </div>
            ))}
          </ListGroup>
        ) : filtered.length === 0 ? (
          <div className="text-muted text-center">Илэрц олдсонгүй</div>
        ) : (
          <ListGroup variant="flush">
            {filtered.map((district) => (
              <button
                key={district.id}
                className="list-group-item list-group-item-action"
                onClick={() => {
                  onSelect(district);
                  onClose();
                }}
              >
                {district.name}
              </button>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
    </Modal>
  );
}
